
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Textarea } from "@/components/ui/textarea";
import { ClientFormData } from "@/types/client";

interface CommunicationSectionProps {
  formData: ClientFormData;
  onFormDataChange: (newData: Partial<ClientFormData>) => void;
}

export const CommunicationSection = ({ formData, onFormDataChange }: CommunicationSectionProps) => {
  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <Label htmlFor="appreciation">Appreciation</Label>
        <Textarea
          id="appreciation"
          placeholder="What do you appreciate about this client?"
          value={formData.appreciation}
          onChange={(e) => onFormDataChange({ appreciation: e.target.value })}
          required
        />
      </div>

      <div className="space-y-2">
        <Label>Email Tone</Label>
        <RadioGroup
          value={formData.emailTone}
          onValueChange={(value) => onFormDataChange({ emailTone: value as ClientFormData['emailTone'] })}
          className="flex flex-col space-y-1"
        >
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="Professional" id="professional" />
            <Label htmlFor="professional">Professional</Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="Casual" id="casual" />
            <Label htmlFor="casual">Casual</Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="Warm & Friendly" id="warm" />
            <Label htmlFor="warm">Warm & Friendly</Label>
          </div>
        </RadioGroup>
      </div>

      <div className="space-y-2">
        <Label>Desired Action</Label>
        <RadioGroup
          value={formData.desiredAction}
          onValueChange={(value) => onFormDataChange({ desiredAction: value as ClientFormData['desiredAction'] })}
          className="flex flex-col space-y-1"
        >
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="Reply to email" id="reply" />
            <Label htmlFor="reply">Reply to email</Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="Schedule a call" id="schedule" />
            <Label htmlFor="schedule">Schedule a call</Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="Will be sending regular updates" id="updates" />
            <Label htmlFor="updates">Will be sending regular updates</Label>
          </div>
        </RadioGroup>
      </div>
    </div>
  );
};
